import * as ww from '@wecom/jssdk';
import { WECOM_CORP_ID, WECOM_AGENT_ID, IS_DEV } from '@/config/env';
import { getWorkWxTicketApi, getWorkWxAgentTicketApi } from '@/api/wecom';

const nav = typeof navigator !== 'undefined' ? navigator : undefined;
const ua = nav?.userAgent || '';
console.log(ua, 'ua');

const wecomVersion = ua?.match(/wxwork\/([\d.]+)/i)?.[1];
export const isWeCom = !!wecomVersion || IS_DEV || true;
export const isWeChat = !isWeCom && /micromessenger/i.test(ua);

// 企业微信配置接口
export interface WecomConfig {
  corpId: string;
  agentId: number;
  jsApiList: string[];
  getConfigSignature?: (
    url: string
  ) => Promise<{ timestamp: number; nonceStr: string; signature: string }>;
  getAgentConfigSignature?: (
    url: string
  ) => Promise<{ timestamp: number; nonceStr: string; signature: string }>;
}

// 默认的 JSAPI 列表
const DEFAULT_JSAPI_LIST = [
  'getExternalContact', // 获取外部联系人信息
  'selectExternalContact', // 选择外部联系人
  'getCurExternalContact', // 获取当前外部联系人
  'sendChatMessage', // 发送聊天消息
  'shareToExternalContact', // 分享到外部联系人
  'openChat', // 打开聊天窗口
  'getContext', // 获取上下文信息
  'getLocation', // 获取地理位置
  'chooseImage', // 选择图片
  'previewImage', // 预览图片
  'uploadImage', // 上传图片
  'downloadImage', // 下载图片
  'getLocalImgData', // 获取本地图片数据
  'startRecord', // 开始录音
  'stopRecord', // 停止录音
  'playVoice', // 播放语音
  'pauseVoice', // 暂停语音
  'stopVoice', // 停止语音
  'uploadVoice', // 上传语音
  'downloadVoice', // 下载语音
  'translateVoice', // 语音转文字
  'getNetworkType', // 获取网络状态
  'openLocation', // 打开地图
  'getLocation', // 获取地理位置
  'startSearchBeacons', // 开始搜索蓝牙设备
  'stopSearchBeacons', // 停止搜索蓝牙设备
  'onSearchBeacons', // 监听蓝牙设备
  'hideMenuItems', // 隐藏菜单项
  'showMenuItems', // 显示菜单项
  'hideAllNonBaseMenuItem', // 隐藏所有非基础菜单项
  'showAllNonBaseMenuItem', // 显示所有非基础菜单项
  'closeWindow', // 关闭窗口
  'scanQRCode', // 扫描二维码
  'chooseWXPay', // 微信支付
  'openProductSpecificView', // 打开商品详情页
  'addCard', // 添加卡券
  'chooseCard', // 选择卡券
  'openCard' // 打开卡券
];

// 企业微信注册配置
export const wecomConfig: WecomConfig = {
  corpId: WECOM_CORP_ID,
  agentId: Number(WECOM_AGENT_ID),
  jsApiList: DEFAULT_JSAPI_LIST
};

export const registerWecom = async () => {
  await ww.register({
    corpId: wecomConfig.corpId,
    agentId: wecomConfig.agentId,
    jsApiList: wecomConfig.jsApiList,
    getConfigSignature: wecomConfig.getConfigSignature,
    getAgentConfigSignature: wecomConfig.getAgentConfigSignature
  });
};

// 初始化企业微信
export const initWecom = async (params: { corpId: string }): Promise<boolean> => {
  try {
    console.log('开始初始化企业微信...');
    const { corpId } = params;
    const url = window.location.href;
    console.log(url, 'url');
    wecomConfig.getConfigSignature = async () => {
      const ticketData = await getWorkWxTicketApi({ corpId, url });
      console.log(ticketData, 'ticketData');
      return {
        timestamp: Number(ticketData.timestamp),
        nonceStr: ticketData.nonceStr,
        signature: ticketData.signature
      };
    };

    const agentTicketData = await getWorkWxAgentTicketApi({ corpId, url });
    wecomConfig.getAgentConfigSignature = async () => {
      console.log(agentTicketData, 'agentTicketData');
      return {
        timestamp: Number(agentTicketData.timestamp),
        nonceStr: agentTicketData.nonceStr,
        signature: agentTicketData.signature
      };
    };

    // 开发环境调试
    // const configSignature = ww.getSignature(
    //   'kgt8ON7yVITDhtdwci0qeaaznm6gs5mICiKFEcvhW88W19SRerP3GtwJfLOS5WabSMO_t3UK_rBAifaNhbL2Nw'
    // );
    // const agentSignature = ww.getSignature('TTcEpWHacUDOuajINckfJw==');

    // console.log(configSignature, agentSignature);

    // wecomConfig.getConfigSignature = () =>
    //   Promise.resolve({
    //     timestamp: Number(configSignature.timestamp),
    //     nonceStr: configSignature.nonceStr,
    //     signature: configSignature.signature
    //   });
    // wecomConfig.getAgentConfigSignature = () =>
    //   Promise.resolve({
    //     timestamp: Number(agentSignature.timestamp),
    //     nonceStr: agentSignature.nonceStr,
    //     signature: agentSignature.signature
    //   });

    // 注册企业微信
    await registerWecom();
    const res1 = await ww.getCurExternalContact();
    const res = await ww.selectExternalContact();

    // console.log(res, 'res');
    // console.log(res1, 'res1');

    console.log('企业微信初始化成功');
    return true;
  } catch (error) {
    console.error('企业微信初始化失败:', error);
    return false;
  }
};

// 企业微信错误处理
export const handleWecomError = (error: any) => {
  console.error('企业微信错误:', error);

  if (error.errMsg) {
    console.error('错误信息:', error.errMsg);
  }

  // 可以根据不同的错误类型进行不同的处理
  switch (error.errMsg) {
    case 'config:invalid':
      console.error('配置无效，请检查 corpId 和 agentId');
      break;
    case 'config:fail':
      console.error('配置失败，请检查签名生成');
      break;
    case 'permission denied':
      console.error('权限不足，请检查 JSAPI 权限');
      break;
    default:
      console.error('未知错误:', error);
  }
};

// 获取当前 URL（用于签名生成）
export const getCurrentUrl = (): string => {
  return window.location.href.split('#')[0];
};

// 企业微信工具函数
export const wecomUtils = {
  // 获取外部联系人信息
  getExternalContact: async (externalUserId: string) => {
    try {
      return await ww.invoke('getExternalContact', { externalUserId });
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  },

  // 选择外部联系人
  selectExternalContact: async () => {
    try {
      return await ww.invoke('selectExternalContact');
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  },

  // 获取当前外部联系人
  getCurExternalContact: async () => {
    try {
      return await ww.invoke('getCurExternalContact');
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  },

  // 发送聊天消息
  sendChatMessage: async (msg: any) => {
    try {
      return await ww.invoke('sendChatMessage', msg);
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  },

  // 打开聊天窗口
  openChat: async (userId: string) => {
    try {
      return await ww.invoke('openChat', { userId });
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  },

  // 获取上下文信息
  getContext: async () => {
    try {
      return await ww.invoke('getContext');
    } catch (error) {
      handleWecomError(error);
      throw error;
    }
  }
};

export default wecomUtils;
